import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatSelectChange } from "@angular/material/select";
import { GridApi } from "ag-grid-community";

@Component({
  selector: "ag-grid-evrideo-footer",
  templateUrl: "./ag-grid-evrideo-footer.component.html",
  styleUrls: ["./ag-grid-evrideo-footer.component.scss"],
})
export class AgGridEvrideoFooterComponent {
  @Input() showPageSizeSelector = true;
  @Input() isInfinite = false;
  @Input() pageSizeOptions: Array<number> = [20, 50, 100];
  @Input() selectedPageSize: number = 100;
  @Input() gridApi: GridApi;

  @Output() pageSizeChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() goToPageClicked: EventEmitter<number> = new EventEmitter<number>();

  onPageSizeChange(event: MatSelectChange) {
    if (this.gridApi) {
      this.gridApi.setGridOption("paginationPageSize", event.value);
      this.gridApi.setGridOption("cacheBlockSize", event.value);
      this.gridApi.purgeInfiniteCache();
    }
    this.pageSizeChanged.emit(event.value);
  }

  get pageCount() {
    let firstRow = 0;
    let lastRow = this.selectedPageSize;
    let finalRow: string | number = "more";
    if (this.gridApi) {
      const pageSize = this.gridApi.paginationGetPageSize();
      const currentPage = this.gridApi.paginationGetCurrentPage();
      firstRow = currentPage * pageSize;
      lastRow = firstRow + pageSize;
      const vc = this.isInfinite
        ? this.gridApi.getInfiniteRowCount()
        : this.gridApi.getDisplayedRowCount();
      if (vc) {
        finalRow = vc;
      }
      if (currentPage + 1 == this.gridApi.paginationGetTotalPages()) {
        lastRow = vc;
      }
    }
    return `${firstRow + 1}-${parseInt(lastRow.toString(), 10)} of ${finalRow}`;
  }
  get pagesView() {
    let thisPage = 0;
    let lastPage: string | number;
    if (this.gridApi) {
      thisPage = this.gridApi.paginationGetCurrentPage();
      lastPage = this.gridApi.paginationGetTotalPages();
      if (!lastPage) {
        lastPage = "more";
      }
    }
    return `Page ${thisPage + 1} of ${lastPage}`;
  }
  goToPage(pos: 'first' | 'previous' | 'next' | 'last'): void {
    if (this.gridApi) {
      switch (pos) {
        case 'first':
          this.gridApi.paginationGoToFirstPage();
          break;
        case 'previous':
          this.gridApi.paginationGoToPreviousPage();
          break;
        case 'next':
          this.gridApi.paginationGoToNextPage();
          break;
        case 'last':
          this.gridApi.paginationGoToLastPage();
          break;
        default:
          break;
      }
      const page = this.gridApi.paginationGetCurrentPage();
      this.goToPageClicked.emit(page);
    }
  }
}
